module.exports = __webpack_public_path__ + "static/media/wifi_tethering.a94dce8b.svg";